import { classNames } from "../../../lib/classNames"

function PopoverListEmpty() {
  return (
    <li
      className={classNames(
        "flex items-center",
        "text-primary text-sm",
        "surface-primary",
        "px-3 py-2"
      )}
    >
      No results found
    </li>
  )
}

export default PopoverListEmpty
